import {
    Box, Button, Checkbox, Flex, Grid, GridItem, IconButton, Image, Input, InputGroup, Link, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, Table, Tag, TagLabel, Tbody, Td, Text, Textarea, Th, Thead, Tooltip, Tr,
    useDisclosure,
} from "@chakra-ui/react";
import { ViewIcon } from "@chakra-ui/icons";
import { CustomToast } from "../../../../components";
import ArrowIcon from "../../../../assets/Images/Arrow-icon.svg";
import HistoryIcon from "../../../../assets/Images/history-icon.svg";
import EditIcon from "../../../../assets/Images/edit-icon.svg";
import UserIcon from "../../../../assets/Images/user-icon.svg";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { showDateTime } from "../../../../utilities/helper";
import { useAuth } from "../../../../hooks/useAuth";
import CustomExpandTable from "../../../../components/CustomExpandTable";
import { Column } from "../../../../components/CustomExpandTable/customExpandTable";
import { applyMask } from "../../../../utilities/masking";
import * as routesNames from "../../../../constant/routes";
import MyDiv from "./MyprojectList.style";
import { useFetch } from "../../../../hooks/useFetch";
import { getStatusStyle, ILead, ILeadTable } from "../../../Leads/LeadPool/model";
import { IProject, IProjectTable, ServiceType } from "../../model";

interface Props {
    leadData: ILeadTable | IProjectTable | any;
    loading: boolean;
    search: string;
    setSearch: React.Dispatch<React.SetStateAction<string>>;
    toggleReveal: (rowIndex: number, field: string) => void;
    maskText: (text?: string) => string;
    handleEditLead: (row: any) => void;
    handleViewLead: (lead: any) => void;
    handleHistoryLead: (lead: any) => void;
    expandedLeadId: number | null;
    toggleRequirementRow: (lead: any) => void;
    maskingSettings: any;
    revealedField: {
        rowIndex: number | null;
        field: string | null;
    };
    loadMyLeads: () => Promise<void>;
    revealedRow: number | null;
    canViewAllContacts: boolean;
    canViewOnlyContacts: boolean;
    canViewRowContacts: boolean;
    canHideContacts: boolean;
    onNavigateLeadDetail?: (lead: any) => void;
    first: number;
}

const MyProjectList = ({
    leadData,
    loading,
    search,
    setSearch,
    toggleReveal,
    maskText,
    handleEditLead,
    handleViewLead,
    handleHistoryLead,
    expandedLeadId,
    toggleRequirementRow,
    maskingSettings,
    revealedField,
    revealedRow,
    canViewAllContacts,
    canViewOnlyContacts,
    canViewRowContacts,
    canHideContacts,
    loadMyLeads,
    onNavigateLeadDetail,
    first,
}: Props) => {
    const navigate = useNavigate();
    const { loginObj } = useAuth();
    const { userName, hasPermission } = useAuth();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);

    const canNavigateLeadDetail =
        hasPermission("MyProject", "NavigateLeadDetail") 
        // hasPermission("Project", "NavigateLeadDetail") ||
        // hasPermission("AllocatedProject", "NavigateLeadDetail") ||
        // hasPermission("MyProject") ||
        // hasPermission("Project") ||
        // hasPermission("AllocatedProject");


    const formatDateOnly = (dateStr?: string | null) => {
        if (!dateStr) return "-";
        try {
            const d = new Date(dateStr);
            if (isNaN(d.getTime())) return String(dateStr);
            return d.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            });
        } catch {
            return String(dateStr);
        }
    };

    const resolveMaskType = (field: string) => {
        if (!maskingSettings || Object.keys(maskingSettings).length === 0) return "Hidden";
        const clean = field.toLowerCase().replace(/[^a-z0-9]/g, "");
        for (const [key, val] of Object.entries(maskingSettings)) {
            const cleanKey = key.toLowerCase().replace(/[^a-z0-9]/g, "");
            if (cleanKey === clean) return val as string;
        }
        if (["company", "companyname", "projectname", "project"].includes(clean)) {
            for (const [key, val] of Object.entries(maskingSettings)) {
                const k = key.toLowerCase().replace(/[^a-z0-9]/g, "");
                if (["company", "companyname", "projectname", "project"].includes(k)) return val as string;
            }
        }
        if (["poc", "pocname", "contactperson", "pocperson"].includes(clean)) {
            for (const [key, val] of Object.entries(maskingSettings)) {
                const k = key.toLowerCase().replace(/[^a-z0-9]/g, "");
                if (["poc", "pocname", "contactperson", "pocperson"].includes(k)) return val as string;
            }
        }
        if (["contact", "contactnumber", "phone", "phonenumber", "pocnumber", "pocphone"].includes(clean)) {
            for (const [key, val] of Object.entries(maskingSettings)) {
                const k = key.toLowerCase().replace(/[^a-z0-9]/g, "");
                if (["contact", "contactnumber", "phone", "phonenumber", "pocnumber", "pocphone"].includes(k)) return val as string;
            }
        }
        if (["email", "pocemail", "emailaddress"].includes(clean)) {
            for (const [key, val] of Object.entries(maskingSettings)) {
                const k = key.toLowerCase().replace(/[^a-z0-9]/g, "");
                if (["email", "pocemail", "emailaddress"].includes(k)) return val as string;
            }
        }
        return (maskingSettings[field] as string) || "Hidden";
    };

    const RevealField = ({
        rowIndex,
        field,
        value,
        isExpanded,
        className,
        children,
    }: {
        rowIndex: number;
        field: string;
        value?: string;
        isExpanded?: boolean;
        className?: string;
        children?: React.ReactNode;
    }) => {
        const isSingleFieldRevealed =
            revealedField.rowIndex === rowIndex &&
            revealedField.field === field;
        const isRowRevealed = revealedRow === rowIndex;
        const shouldShowValue =
            canViewAllContacts ||
            isSingleFieldRevealed ||
            isRowRevealed;

        const maskType = resolveMaskType(field);

        const tooltipValue = shouldShowValue
            ? value
            : canHideContacts
                ? applyMask(value || "", maskType)
                : "";

        return (
            <Box position="relative">
                <Tooltip
                    label={tooltipValue}
                    hasArrow
                    placement="top"
                    isDisabled={!tooltipValue}
                >
                    <Box
                        userSelect={shouldShowValue ? "auto" : "none"}
                        filter={
                            shouldShowValue
                                ? "none"
                                : canHideContacts
                                    ? "none"
                                    : "blur(4px)"
                        }
                    >
                        {shouldShowValue ? (
                            children ? (
                                children
                            ) : (
                                <Text
                                    whiteSpace={isExpanded ? "normal" : "nowrap"}
                                    className={`font-poppins text_sm text_medium ${className || ""}`}
                                    maxW="200px"
                                    isTruncated
                                >
                                    {value}
                                </Text>
                            )
                        ) : (
                            <Text
                                whiteSpace={isExpanded ? "normal" : "nowrap"}
                                className={`font-poppins text_sm text_medium ${className || ""}`}
                                maxW="200px"
                                isTruncated
                            >
                                {canHideContacts
                                    ? applyMask(value || "", maskType)
                                    : value}
                            </Text>
                        )}
                    </Box>
                </Tooltip>
                {!canViewAllContacts && !shouldShowValue && !canHideContacts && (
                    <Flex
                        position="absolute"
                        top="50%"
                        left="50%"
                        transform="translate(-50%, -50%)"
                        zIndex={2}
                    >
                        <Flex
                            align="center"
                            gap={1}
                            bg="#F2F4F7"
                            border="1px solid #E4E7EC"
                            borderRadius="8px"
                            px="10px"
                            py="3px"
                            cursor="pointer"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleReveal(rowIndex, field);
                            }}
                        >
                            <Text fontSize="11px" fontWeight="600" color="#344054">
                                View
                            </Text>
                            <ViewIcon color="#344054" boxSize={3} />
                        </Flex>
                    </Flex>
                )}
            </Box>
        );
    };

    const getDisplayValue = (value: string, field: string, rowIndex: number) => {
        const isSingleFieldRevealed =
            revealedField.rowIndex === rowIndex &&
            revealedField.field === field;
        const isRowRevealed = revealedRow === rowIndex;
        const shouldShowValue =
            canViewAllContacts ||
            isSingleFieldRevealed ||
            isRowRevealed;

        const maskType = resolveMaskType(field);

        return shouldShowValue
            ? value
            : canHideContacts
                ? applyMask(value || "", maskType)
                : value;
    };



    const renderStatusBadge = (statusName?: string | null) => {
        const status = statusName || "Won";
        const statusStyle = getStatusStyle(status);
        return (
            <Box
                display="inline-flex"
                alignItems="center"
                bg={statusStyle?.bg || "#DCFCE7"}
                color={statusStyle?.color || "#15803D"}
                px="10px"
                py="4px"
                borderRadius="16px"
                fontSize="12px"
                fontWeight="600"
            >
                <Text m={0}>{status}</Text>
            </Box>
        );
    };

    const renderActiveBadge = (isActiveVal?: any) => {
        const isActive = isActiveVal === true || isActiveVal === "true" || isActiveVal === 1;
        return (
            <Box
                display="inline-flex"
                alignItems="center"
                bg={isActive ? "#DCFCE7" : "#FEE2E2"}
                color={isActive ? "#15803D" : "#DC2626"}
                px="10px"
                py="4px"
                borderRadius="16px"
                fontSize="12px"
                fontWeight="600"
            >
                <Text m={0}>{isActive ? "Active" : "Inactive"}</Text>
            </Box>
        );
    };

    const NavigateLeadDetail = (lead: any) => {
        if (onNavigateLeadDetail) {
            onNavigateLeadDetail(lead);
            return;
        }

        navigate(routesNames.PROJECTDETAIL, {
            state: {
                fullScreen: true,
                from: routesNames.MYPROJECT,
                fromLabel: "My Project",
                lead: {
                    projectId: lead.projectId || lead.id,
                    projectAmount: lead.projectAmount,
                    projectDuration: lead.projectEstimatedDuration || lead.projectDuration,
                    projecStartDate: lead.projectStartDate || lead.projecStartDate,
                    projectStartDate: lead.projectStartDate || lead.projecStartDate,
                    projectEndDate: lead.projectEndDate,
                    serviceType: lead.serviceType,
                    serviceInterestedIn: lead.serviceInterestedIn,
                    serviceInterestedInIds: lead.serviceInterestedInIds,
                    bdmName: lead.bdmName,
                    preSalesName: lead.preSalesName,
                    sourceName: lead.sourceName || lead.project?.sourceName,
                    leadId: lead.leadId,
                    companyId: lead.companyId || lead.project?.companyId,
                    companyName: lead.companyName || lead.projectName,
                    projectName: lead.projectName || lead.companyName,
                    pocName: lead.pocName,
                    contact: lead.contact,
                    countryCode: lead.countryCode,
                    email: lead.email,
                    assignedToUser: lead.assignedToUser,
                    leadStatus: lead.projectStatus || lead.leadStatus,
                    leadStatusId: lead.leadStatusId,
                    createdBy: lead.createdBy,
                    createdAt: lead.createdAt,
                    upcomingMeetingCount: lead.upcomingMeetingCount,
                    upcomingFollowupCount: lead.upcomingFollowupCount,
                    isAccepted: lead.isAccepted,
                },
            },
        });
    };



    return (
        <MyDiv>
            <Box>
                <Grid className="grid_container" mt={10}>
                    <GridItem colSpan={12}>
                        <Box
                            mt={4}
                            overflowX="auto"
                            borderRadius="16px"
                            sx={{ "&::-webkit-scrollbar": { height: "2px" } }}
                        >
                            <CustomExpandTable
                                autoCloseExpand={true}
                                loading={loading}
                                value={leadData?.leads || []}
                                rowKey="projectId"
                                emptyMessage="No Projects Found"
                                getRowBgColor={(row: any) =>
                                    row.isAccepted === false
                                        ? "#FFECEC"
                                        : row.isAccepted === null
                                            ? "#FFF4E5"
                                            : undefined
                                }
                                onRowClick={(row: any) =>
                                    canNavigateLeadDetail && NavigateLeadDetail(row)
                                }
                                renderExpandedContent={(row: any) => <></>}
                            >
                                {/* 1. S.No */}
                                <Column
                                    header="S.No"
                                    body={(_, index) => first + index + 1}
                                />

                                {/* 2. Project Name */}
                                <Column
                                    header="Project Name"
                                    body={(row: any, index: number) => {
                                        const projName =
                                            row.projectName ||
                                            row.project?.projectName ||
                                            row.companyName ||
                                            "-";
                                        return (
                                            <Tooltip label={projName} hasArrow placement="top"
                                            >
                                                <Box
                                                    color="#2563EB"
                                                    fontWeight="600"
                                                    maxW="200px"
                                                    isTruncated
                                                    cursor={canNavigateLeadDetail ? "pointer" : "default"}
                                                    onClick={
                                                        canNavigateLeadDetail
                                                            ? (e) => {
                                                                e.stopPropagation();
                                                                NavigateLeadDetail(row);
                                                            }
                                                            : undefined
                                                    }
                                                >
                                                    {projName}
                                                </Box>
                                            </Tooltip>
                                        );
                                    }}
                                />

                                {/* 3. Poc Name */}
                                <Column header="Poc Name" body={(row: any, index: number) => {
                                    const poc =
                                        row.pocName ??
                                        row.project?.pocName ??
                                        "-";
                                    return (
                                        <Tooltip
                                            label={getDisplayValue(poc, "poc", index)}
                                            hasArrow
                                            placement="top"
                                        >
                                            <Box maxW="180px" isTruncated>
                                                <RevealField
                                                    rowIndex={index}
                                                    field="poc"
                                                    value={poc}
                                                />
                                            </Box>
                                        </Tooltip>
                                    );
                                }}
                                />

                                {/* 4. Poc Number */}
                                <Column
                                    header="Poc Number"
                                    body={(row: any, index: number) => {
                                        const rawContact =
                                            row.contact ??
                                            row.project?.contact ??
                                            "";
                                        const countryCode =
                                            row.countryCode ??
                                            row.project?.countryCode ??
                                            "";
                                        const fullContact = rawContact
                                            ? countryCode
                                                ? `${countryCode} ${rawContact}`
                                                : rawContact
                                            : "-";
                                        return (
                                            <RevealField
                                                rowIndex={index}
                                                field="contact"
                                                value={fullContact}
                                            />
                                        );
                                    }}
                                />

                                {/* 5. Poc Email */}
                                <Column
                                    header="Poc Email"
                                    body={(row: any, index: number) => {
                                        const email =
                                            row.email ??
                                            row.project?.email ??
                                            "-";
                                        return (
                                            <RevealField
                                                rowIndex={index}
                                                field="email"
                                                value={email}
                                            />
                                        );
                                    }}
                                />

                                {/* Project Won Date */}
                                <Column
                                    header="Project Won Date"
                                    body={(row: any) => (
                                        <Text whiteSpace="nowrap" fontSize="13px" fontWeight="500">
                                            {formatDateOnly(
                                                row.projectWonDate ||
                                                row.wonDate ||
                                                row.project?.projectWonDate ||
                                                row.project?.wonDate
                                            )}
                                        </Text>
                                    )}
                                />

                                {/* 5. Project Start Date */}
                                <Column
                                    header="Project Start Date"
                                    body={(row: any) => (
                                        <Text whiteSpace="nowrap" fontSize="13px" fontWeight="500">
                                            {formatDateOnly(
                                                row.projectStartDate ||
                                                row.projecStartDate ||
                                                row.project?.projectStartDate ||
                                                row.project?.projecStartDate
                                            )}
                                        </Text>
                                    )}
                                />

                                {/* 6. Project End Date */}
                                <Column
                                    header="Project End Date"
                                    body={(row: any) => (
                                        <Text whiteSpace="nowrap" fontSize="13px" fontWeight="500">
                                            {formatDateOnly(
                                                row.projectEndDate ||
                                                row.project?.projectEndDate
                                            )}
                                        </Text>
                                    )}
                                />

                                {/* 7. Project Amount */}
                                <Column
                                    header="Project Amount"
                                    body={(row: any) => {
                                        const amt = row.projectAmount ?? row.project?.projectAmount;
                                        return (
                                            <Text whiteSpace="nowrap" fontSize="13px" fontWeight="600" color="gray.800">
                                                {amt !== undefined && amt !== null && amt !== ""
                                                    ? `₹${Number(amt).toLocaleString()}`
                                                    : "-"}
                                            </Text>
                                        );
                                    }}
                                />

                                {/* 8. Project Estimated Duration */}
                                <Column
                                    header="Project Estimated Duration"
                                    body={(row: any) => {
                                        const dur =
                                            row.projectEstimatedDuration ??
                                            row.projectDuration ??
                                            row.project?.projectEstimatedDuration ??
                                            row.project?.projectDuration;
                                        return (
                                            <Text whiteSpace="nowrap" fontSize="13px" fontWeight="500">
                                                {dur !== undefined && dur !== null && dur !== ""
                                                    ? `${dur} Months`
                                                    : "-"}
                                            </Text>
                                        );
                                    }}
                                />

                                {/* 9. BDM Name */}
                                <Column
                                    header="BDM Name"
                                    body={(row: any) => (
                                        <Text whiteSpace="nowrap" fontSize="13px">
                                            {row.bdmName ||
                                                row.project?.bdmName ||
                                                row.bdm ||
                                                row.assignedToUser ||
                                                "-"}
                                        </Text>
                                    )}
                                />
                                {/* 12. Project Status */}
                                <Column
                                    header="Project Status"
                                    body={(row: any) =>
                                        renderStatusBadge(
                                            row.projectStatus ||
                                            row.leadStatus ||
                                            row.status ||
                                            "Won"
                                        )
                                    }
                                />

                                {/* 13. Status (Active / Inactive) */}
                                <Column
                                    header="Status"
                                    body={(row: any) =>
                                        renderActiveBadge(
                                            row.isActive ??
                                            row.project?.isActive ??
                                            true
                                        )
                                    }
                                />
                            </CustomExpandTable>
                        </Box>




                    </GridItem>
                </Grid>
            </Box>
        </MyDiv>
    );
};

export default MyProjectList;